var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLittleMailIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.833,
    height: 21.962,
    viewBox: "0 0 28.833 21.962",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5684",
    "data-name": "Trac\\xE9 5684",
    d: "M28.833,2.534A2.538,2.538,0,0,0,26.3,0H2.534A2.538,2.538,0,0,0,0,2.534V19.428a2.538,2.538,0,0,0,2.534,2.534H26.3a2.538,2.538,0,0,0,2.534-2.534ZM1.689,2.876l8.136,8.066L1.689,19.078ZM14.47,13.168,2.892,1.689H25.948Zm-3.445-1.036,2.853,2.828a.845.845,0,0,0,1.192,0l2.781-2.782,8.1,8.1H2.884Zm8.021-1.15,8.1-8.1V19.078Z",
    fill: "#4188f2"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLittleMailIcon);
export default __webpack_public_path__ + "static/media/little-mail-icon.5f89f250d1cc20e9ffbfdcc4787f95f4.svg";
export { ForwardRef as ReactComponent };